import { render, staticRenderFns } from "./Workday.vue?vue&type=template&id=13b3953d&scoped=true&"
import script from "./Workday.vue?vue&type=script&lang=js&"
export * from "./Workday.vue?vue&type=script&lang=js&"
import style0 from "./Workday.vue?vue&type=style&index=0&id=13b3953d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b3953d",
  null
  
)

export default component.exports